<template>
  <Panel
    class="tournament-info-wrapper_game-selector"
    :variant="['30-paddings', 'default', 'rounded']"
  >
    <TournamentGameSetting />
    <TournamentPlatformSetting />
  </Panel>
</template>

<script>
import Panel from '@/components/atoms/Panel';
import TournamentGameSetting from '@/views/tournaments/management/singleTournament/components/SettingsGame';
import TournamentPlatformSetting from '@/views/tournaments/management/singleTournament/components/SettingsPlatform';
export default {
  name: 'GameAndPlatformSection',
  components: {
    Panel,
    TournamentGameSetting,
    TournamentPlatformSetting,
  },
  watch: {
    '$route.path'() {
      return;
    },
  },
};
</script>
